export const layoutsTypes = {
  // PRESENTATION: "presentation",
  PUBLIC: "public",
};
